<template>
    <div class="call">
      <div class="call-c">
          <div>
              <i class="el-icon-phone-outline"></i>
              <a href="tel:85264586539">熱綫查詢</a>
          </div>
          <div>
              <i style="position: relative;top: 3px;"><img src="../assets/images/w.png" alt="" width="17" height="17"></i>
              <a href="https://api.whatsapp.com/send?phone=85264586539&text=hello 到會家,我想訂到會！😋">即時查詢</a>
          </div>
      </div>
    </div>
</template>
<script>
export default {
  data () {
    return {

    }
  }
}
</script>
<style scoped>
    .call-c{display: none;}
    @media (max-width: 820px) {
        .call-c{
            background: #EB6410;
            display: flex;
            flex-wrap: nowrap;
            height: 40px;
            line-height: 40px;
        }
        .call-c>div{
            text-align: center;
            flex: 1 0 49%;
            color: white;
        }
        .call-c>div:nth-child(1){
            border-right:1px solid #eee;
        }
        .call-c a{
            text-decoration: none;
            color: white;
        }
    }
</style>
